// @ts-ignore
export const lastCatchment = (state) => state.lastCatchment;
// @ts-ignore
export const map = (state) => state.map;
// @ts-ignore
export const tileSource = (state) => state.tileSource;
// @ts-ignore
export const tiles = (state) => state.tiles;
// @ts-ignore
export const view = (state) => state.view;
// @ts-ignore
export const quickCatchment = (state) => false;
// @ts-ignore
export const gps = (state) => state.gps;
// @ts-ignore
export const name = (state) => state.name;
